import { Component, Input, OnInit } from '@angular/core';
import { ExcelService } from 'src/app/services/export/excel.service';

@Component({
    selector: 'app-modal-exportar',
    templateUrl: './modal-exportar.component.html',
    styleUrls: ['./modal-exportar.component.css'],
    standalone: false
})
export class ModalExportarComponent {
 ServicioExcel= new ExcelService();
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() buttonText: string = 'Exportar';
  @Input() data;
  @Input() nameFile;

  
  isVisible: boolean = false;


  open() {
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
  }
  
  async exportarDataExcel(): Promise<void> {
    await this.ServicioExcel.exportAsExcelFile(this.data, this.nameFile);
    this.close();
  }
}


